import React from "react";
import "./Blogs.css";

const Blogs = () => {
  return (
    <div className="blog-container">
      <div>
        <h2 className="question">What is context api?</h2>
        <p>
          A React app can use the React Context API to generate global variables
          that can be passed around. This is an alternative to "prop drilling,"
          which entails passing props from grandparent to child to parent and so
          on. Context is also marketed as a simpler, lighter way to Redux state
          management. Context API is a new feature in React that allows you to
          easily and lightly communicate state throughout your whole app.
        </p>
      </div>
      <div>
        <h2 className="question">What is semantic tag?</h2>
        <p>
          HTML was established to describe documents on the early internet as a
          markup language. As the internet expanded in popularity and more
          people used it, its requirements evolved. People wanted to share other
          items on the internet, which was originally intended for sharing
          scientific documents. People began to desire to make the web appear
          nicer quite rapidly.
        </p>
      </div>
    </div>
  );
};

export default Blogs;
